export default __webpack_public_path__ + "static/media/Universe - NFT Fest - desktop and mobile.ea3494b3.png";